<template>
  <div class="identidade-visual-intro-content" id="identidade-visual-introducao" data-search-anchor>
    <div class="intro-identidade-visual-content">
      <h1 class="intro-identidade-title-id-visual">{{ introTitle }}</h1>
      <div class="intro-identidade-description-content">        
        <p class="intro-identidade-description-paragraph" style="white-space: pre-line">{{ introDescriptionParagraph1 }}</p>
        <p class="intro-identidade-description-paragraph">{{ introDescriptionParagraph2 }}</p>
        <p class="intro-identidade-description-paragraph" style="margin-bottom: 1rem;">{{ introDescriptionParagraph3 }}</p>
      </div>
      
    </div>
    <div class="identidade-visual-intro-card-item" :style="{ backgroundImage: `url(${introImageSrc})` }"></div>
    <div class="identidade-visual-intro-wrapper">
      <h1 class="identidade-visual-intro-title">{{ layoutIntroTitle }}</h1>
      <div class="identidade-visual-description-content">
        <p class="identidade-visual-intro-description">{{ layoutIntroDescription }}</p>
        <p class="identidade-visual-intro-description">{{ layoutIntroDescription2 }}</p>
        <p class="identidade-visual-intro-description-2">{{ layoutIntroDescription3 }}</p>
      </div>
    </div> 
  </div>    
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class LayoutsIntroSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

   get introTitle(): string {
    return this.getElementTitle(1, 0)
  }

  get introDescriptionParagraph1(): string {
    return this.getElementText(1, 0)
  }

  get introDescriptionParagraph2(): string {
    return this.getElementText(1, 1)
  }

  get introDescriptionParagraph3(): string {
    return this.getElementText(1, 2)
  }

  get introImageSrc(): string {
    return this.getElementMedia(1, 2)
  }

  get layoutIntroTitle(): string {
    return this.getElementText(1, 3)
  }

  get layoutIntroDescription(): string {
    return this.getElementText(1, 4)
  }

  get layoutIntroDescription2(): string {
    return this.getElementText(1, 5)
  }

  get layoutIntroDescription3(): string {
    return this.getElementText(1, 6)
  }
 
  async getColorPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getColorPage()
    }
  }
}
</script>

<style lang="scss">
.identidade-visual-intro-content {
  display: flex;
  align-items: center;  
  flex-direction: column;
  width: 100%;
}

.intro-identidade-visual-content {  
  display: grid;
  grid-template-columns: 48% 50%;
  justify-content: space-between;  
  width: 100%;  
}

.intro-identidade-title-id-visual {  
  font-size: 65px;
  font-weight: 400;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  padding: 0 5rem 0 0rem;
  margin: 0;
}

.intro-identidade-description-content {
  width: 488px;
}

.intro-identidade-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.intro-identidade-description-paragraph {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.identidade-visual-intro-card-item {
  position: relative;  
  width: 100%;  
  max-width: 1032px;
  height: 166px;

  background-repeat: no-repeat;  
  background-size:cover;  
  margin-top: 17px;
}

@media (max-width: 1440px) {
  .identidade-visual-intro-card-item {
    padding-left: 0;
  }
}

.identidade-visual-intro-wrapper {
  display: grid;
  grid-template-columns: 50% 50%;  
  width: 100%;
  max-width: 1032px;
  padding-top: 6.25rem;
}

.identidade-visual-intro-title {  
  font-size: 65px;
  font-weight: 400;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;  
  margin: 0;
}

.identidade-visual-description-content {
  width: 430px; 
}

.identidade-visual-intro-description,
.identidade-visual-intro-description-2 {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.identidade-visual-intro-description-2{
  margin-bottom: 0;
}
</style>
